export default "__VITE_ASSET__ibb0UDph__"